import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Panel } from "primereact/panel";
import { useEffect, useState } from "react";
import { buscarAnaliseAcaoGeral, deleteAnaliseAcaoGeral } from "../../../../../../service/Rag/lançamento/acao";
import DevolutivaUnidadeAcaoSetorial2024 from "./DevolutivaUnidadeAcaoSetorial2024";
import ModalAnaliseGeralAcaoSeplag2024 from "./ModalAnaliseGeralAcaoSeplag2024";
import { buscarCronogramaPorParametroExercicioAtivoResumido } from "../../../../../../service/Rag/Cronograma";

const AnaliseGeralAcaoSeplag2024 = ({
  setAtualizarData,
  dadosItemAcao,
  permissionUser,
  ListaAnaliseAcaoDevolutiva,
  setData,
  data,
}) => {
  const [_dataRowOrgaoCentral, setdataRowOrgaoCentral] = useState();

  const [visibleModal, setVisibleModal] = useState(false);
  const [cronograma, setCronograma] = useState(null);
  const [visibleModaldevolutiva, setVisibleModalDevolutiva] = useState(false);
  const [actionModal, setActionModal] = useState({
    edit: false,
    disbled: false,
    create: false,
  });
  const [actionModalDevolutiva, setActionModaDevolutiva] = useState({
    edit: false,
    disbled: false,
    create: false,
  });
  const analiseItemAcaoOptions = [
    { name: "Indicador da Ação", code: 0 },
    { name: "Meta física", code: 1 },
    { name: "Execução Orçamentária", code: 2 },
    { name: "Outros", code: 3 },
  ];
  const analiseRecomendacaoAcaoOptions = [
    { name: "Baixo Impacto", code: 0 },
    { name: "Médio Impacto", code: 1 },
    { name: "Alto Impacto", code: 2 },
  ];
  const respostaSetorialAcaoOptions = [
    { name: "Não acatado", code: 0 },
    { name: "Acatado", code: 1 },
    { name: "Parcialmente acatado", code: 2 },
  ];
  const [dataRow, setDataRow] = useState([]);

  useEffect(() => {
    if (dadosItemAcao.ptaFiplan.exercicio.idenExercicio && cronograma === null) {
      buscarCronogramaPorParametroExercicioAtivoResumido(dadosItemAcao.ptaFiplan.exercicio.idenExercicio).then(
        (res) => {
          setCronograma(res.data);
          return res.data;
        }
      );
    }
  }, []);

  const actionTemplate = (node) => {
    let buttonEditar;
    let buttonVer;
    let buttonDelete;
    let buttonDevolutiva;
    if (permissionUser.edit === true) {
      buttonEditar = (
        <Button
          className="p-button-warning button-margin-left p-button p-component p-button-icon-only"
          style={{ marginRight: ".5em" }}
          onClick={() => {
            editarAnaliseGeralSeplag(node);
          }}
        >
          <i className="pi pi-pencil"></i>
        </Button>
      );
      buttonDelete = (
        <Button
          className="p-button-danger button-margin-left p-button p-component p-button-icon-only"
          onClick={() => {
            confirm(node);
          }}
        >
          <i className="pi pi-trash"></i>
        </Button>
      );
    }
    if (permissionUser.view === true) {
      buttonVer = (
        <Button
          className="p-button-info p-button p-component p-button-icon-only"
          onClick={() => {
            vizualizarAnaliseGeral(node);
          }}
          style={{ marginRight: ".5em" }}
        >
          <i className="pi pi-search"></i>
        </Button>
      );

      buttonDevolutiva = (
        <Button
          className="p-button-info p-button p-component p-button-icon-only"
          onClick={() => {
            dialogDevolutiva(node);
          }}
          style={{ marginLeft: ".5em" }}
        >
          <i
            className="pi pi-sitemap
"
          ></i>
        </Button>
      );
    }

    return (
      <div className="formgroup-inline">
        <div className="field-checkbox">
          {buttonEditar}
          {buttonVer}
          {buttonDelete}
          {buttonDevolutiva}
        </div>
      </div>
    );
  };
  const confirm = (_data) => {
    confirmDialog({
      message: "Deseja realmente excluir?",
      header: "Confirmação de exclusão",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => deleteGeralSeplag(_data),
      reject: () => {},
    });
  };

  const cadastrarDevolutiva = (_data) => {
    setVisibleModalDevolutiva(true);
    setActionModaDevolutiva({
      edit: false,
      disbled: false,
      create: true,
    });
    setdataRowOrgaoCentral(_data);
  };
  const dialogDevolutiva = (_data) => {
    confirmDialog({
      message: "Devolutiva da Unidade Setorial",
      header: "",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Cadastrar nova Devolutiva",
      rejectLabel: "Cancelar",
      accept: () => cadastrarDevolutiva(_data),
      reject: () => {},
    });
  };
  const vizualizarAnaliseGeral = (_data) => {
    setDataRow(_data);
    setVisibleModal(true);
    setActionModal({
      edit: false,
      disabled: true,
      create: false,
    });
  };
  const editarAnaliseGeralSeplag = (_data) => {
    setDataRow(_data);
    setVisibleModal(true);
    setActionModal({
      edit: true,
      disabled: false,
      create: false,
    });
  };

  const deleteGeralSeplag = async (_data) => {
    await deleteAnaliseAcaoGeral(_data.idenAnaliseAcao).then((_res) => {
      window.$toast.current.show({
        severity: "success",
        summary: "Ação Efetuada",
        detail: "Deletado com Sucesso",
        life: 5000,
      });
      setAtualizarData(true);
    });
  };

  const onAdicionarDado = () => {
    setDataRow([]);
    setVisibleModal(true);
    setActionModal({
      edit: false,
      disbled: false,
      create: true,
    });
  };
  const header = () => {
    if (permissionUser.edit === true) {
      return (
        <div className="table-header">
          <Button
            onClick={() => {
              onAdicionarDado();
            }}
            className="p-button-info p-button p-component p-button-icon-only"
          >
            <i className="pi pi-plus-circle"></i>
          </Button>
        </div>
      );
    }
  };
  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + "...";
    }
    return text;
  };

  const getItemDescription = (code) => {
    const found = analiseItemAcaoOptions.find((item) => item.code === code);
    return found ? found.name : code;
  };

  const getRecomendacaoDescription = (code) => {
    const found = analiseRecomendacaoAcaoOptions.find((item) => item.code === code);
    return found ? found.name : code;
  };
  function onPageDataAnalise(event) {
    buscarAnaliseAcaoGeral(dadosItemAcao.idenPtaMonitora, event.page).then((_res) => {
      setData((prevState) => ({
        ...prevState,
        listaAnaliseAcaototalPages: _res?.totalPages ? _res.totalPages : 0,
        listaAnalisetotalElements: _res?.totalElements ? _res.totalElements : 0,
        OrgCentralnumber: _res?.number,
        ListaAnaliseAcao: _res.content.sort((a, b) => {
          if (a.idenAnaliseAcao > b.idenAnaliseAcao) {
            return 1;
          }
          if (a.idenAnaliseAcao < b.idenAnaliseAcao) {
            return -1;
          }
          return 0;
        }),
      }));
    });
    //  buscarUsuario(event.page, 10);
  }

  return (
    <>
      <Panel header="Análise da Ação pela equipe do Órgão Central">
        <DataTable
          header={header}
          emptyMessage="Nenhum registro encontrado"
          showGridlines
          value={data.ListaAnaliseAcao}
          dataKey="idenAnaliseAcao"
          paginator={true}
          rows={10}
          size={10}
          lazy
          first={data.OrgCentralnumber * 10}
          totalRecords={data.listaAnalisetotalElements}
          onPage={onPageDataAnalise}
        >
          <Column field="conOrdemAnaliseAcao" header="Ordem" />
          <Column
            field="numrItemAnaliseAcao"
            header="Item"
            body={(rowData) => getItemDescription(rowData.numrItemAnaliseAcao)}
          />
          <Column
            field="numrAnaliseRecomendacao"
            header="Classificação"
            body={(rowData) => getRecomendacaoDescription(rowData.numrAnaliseRecomendacao)}
          />
          <Column
            field="descAnaliseAcao"
            header="Análise/recomendação do Item"
            body={(rowData) => truncateText(rowData.descAnaliseAcao, 400)}
          />
          <Column field="dataAnaliseAcao" header="Data" />
          <Column field="nomeAnalistaOrgaoCentral" header="Analista Órgão Central" />

          <Column body={actionTemplate} header="Ações" />
        </DataTable>
      </Panel>

      <DevolutivaUnidadeAcaoSetorial2024
        ListaAnaliseAcaoDevolutiva={ListaAnaliseAcaoDevolutiva}
        setAtualizarData={setAtualizarData}
        dadosItemAcao={dadosItemAcao}
        permissionUser={permissionUser}
        visibleModaldevolutiva={visibleModaldevolutiva}
        setVisibleModalDevolutiva={setVisibleModalDevolutiva}
        setActionModaDevolutiva={setActionModaDevolutiva}
        actionModalDevolutiva={actionModalDevolutiva}
        _dataRowOrgaoCentral={_dataRowOrgaoCentral}
        data={data}
      />
      {visibleModal && (
        <ModalAnaliseGeralAcaoSeplag2024
          visibleModal={visibleModal}
          setVisibleModal={setVisibleModal}
          actionModal={actionModal}
          setActionModal={setActionModal}
          setAtualizarData={setAtualizarData}
          dataRow={dataRow}
          dadosItemAcao={dadosItemAcao}
          cronograma={cronograma}
        />
      )}
    </>
  );
};
export default AnaliseGeralAcaoSeplag2024;
